
import { useToast } from '@/hooks/use-toast';
import { CardDetails } from '@/types/payment'; 
import { supabase } from '@/integrations/supabase/client';

export const usePaymentSubmit = () => {
  const { toast } = useToast();
  
  const handlePaymentSetup = async (
    userId: string, 
    cardData: CardDetails,
    verificationScore?: number,
    bitcoinAddress?: string
  ) => {
    try {
      // Store the payment method in Supabase
      const { error } = await supabase.from('payment_methods').insert({
        user_id: userId,
        is_default: true,
        payment_method_type: bitcoinAddress ? 'bitcoin' : 'card',
        last_four_digits: bitcoinAddress 
          ? bitcoinAddress.slice(-4)  // Last 4 chars of Bitcoin address
          : cardData.cardNumber.slice(-4), // Last 4 digits of card
        card_type: bitcoinAddress ? 'Bitcoin' : 'Visa', // Changed from card_brand
        expiry_date: bitcoinAddress ? null : cardData.expiryDate,
        metadata: {
          verification_score: verificationScore || 0,
          verified: verificationScore ? verificationScore > 70 : false,
          bitcoin_address: bitcoinAddress,
          balance: 100.00, // Add initial balance for demo
          cardholder_name: bitcoinAddress ? null : cardData.cardholderName
        }
      });

      if (error) {
        throw new Error(`Failed to save payment method: ${error.message}`);
      }
      
      toast({
        title: "Payment method saved",
        description: bitcoinAddress 
          ? "Your Bitcoin address has been verified and saved" 
          : "Your card has been verified and saved",
        variant: "default",
      });
      
      return true;
    } catch (error: any) {
      console.error('Payment setup error:', error);
      toast({
        title: "Payment setup failed",
        description: error.message || "Failed to save payment method",
        variant: "destructive",
      });
      return false;
    }
  };

  return { handlePaymentSetup };
};
